import { render, staticRenderFns } from "./GrandPrizePicture.vue?vue&type=template&id=2092d1c4&scoped=true&"
import script from "./GrandPrizePicture.vue?vue&type=script&lang=js&"
export * from "./GrandPrizePicture.vue?vue&type=script&lang=js&"
import style0 from "./GrandPrizePicture.vue?vue&type=style&index=0&id=2092d1c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2092d1c4",
  null
  
)

export default component.exports